import { render, staticRenderFns } from "./StockTable.vue?vue&type=template&id=83ae00cc"
import script from "./StockTable.vue?vue&type=script&lang=js"
export * from "./StockTable.vue?vue&type=script&lang=js"
import style0 from "./StockTable.vue?vue&type=style&index=0&id=83ae00cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports